import script from "./JobDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDescription.vue?vue&type=script&setup=true&lang=js"

import "./JobDescription.vue?vue&type=style&index=0&id=47a0d072&lang=scss&scoped=true"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47a0d072"]])

export default __exports__